export interface EChartsInstanceLike {
  group: string
  getConnectedDataURL: (opts: { pixelRatio: number; backgroundColor: string }) => string | undefined
}

/**
 * Captures the current chart as a PNG and triggers a browser download.
 *
 * Temporarily removes the instance from its sync group so that only the
 * current chart (not all connected charts) is included in the screenshot,
 * then restores the group immediately after capture.
 */
export async function downloadEChartsInstance(
  instance: EChartsInstanceLike,
  { groupId, filename = 'chart' }: { groupId: string; filename?: string },
): Promise<void> {
  instance.group = ''
  const fileUrl = instance.getConnectedDataURL({ pixelRatio: 2, backgroundColor: '#fff' })
  instance.group = groupId

  if (!fileUrl) return

  const blob = await fetch(fileUrl).then(r => r.blob())
  const link = document.createElement('a')
  link.href = URL.createObjectURL(blob)
  link.download = `${filename}.png`
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
